/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : EDIT : DELETE --------------- ++++++++++ */
const deleteHelperSize = 18;
const deletePosition = deleteHelperSize / 2;
export default theme => ({
	delete: {
		background: `rgba(0, 0, 0, 0.5)`,
		borderRadius: pxToEm(4),
		color: theme.color.light.light.swatch,
		cursor: 'pointer',
		padding: replacePXinStringWithEM(`5px 8px`),
		textAlign: 'center',
		position: 'absolute',
		zIndex: '10',
		transition: 'background .2s linear 0s',
		lineHeight: '1',
		'& .icon': {
			fontSize: '80%'
		},
		'&:hover': {
			background: `rgba(0, 0, 0, 0.9)`
		},
		'&.top': { top: `-${pxToEm(deletePosition)}` },
		'&.right': { right: `-${pxToEm(deletePosition)}` },
		'&.bottom': { bottom: `-${pxToEm(deletePosition)}` },
		'&.left': { left: `-${pxToEm(deletePosition)}` },
	}
});
